import classnames from 'classnames';
import React, { forwardRef, Ref } from 'react';

import '@eika/button-style';
import { Icon } from '@eika/icon';

import { SharedButtonProps } from './Props';
import { isStandardIcon, mapButtonTypes, mapIconSizes } from './mapper';

export type ButtonProps = SharedButtonProps;

const Button = forwardRef(
    (
        {
            children,
            className,
            buttonType = 'positive',
            size = 'standard',
            icon,
            type = 'button',
            inverted = false,
            iconOnRightSide = false,
            ...rest
        }: ButtonProps,
        ref: Ref<HTMLButtonElement>,
    ): JSX.Element => {
        const { type: targetButtonType, size: targetButtonSize } = mapButtonTypes(buttonType, size);
        const iconClassNames = mapIconSizes(targetButtonType, targetButtonSize);

        return (
            <button
                {...rest}
                // eslint-disable-next-line react/button-has-type
                type={type}
                className={classnames(
                    'sgw-button',
                    'sgw-button-common',
                    className,
                    `button--${targetButtonType}`,
                    `button--size-${targetButtonSize}`,
                    {
                        'action-button__button': targetButtonType === 'action',
                        inverted,
                    },
                )}
                ref={ref}
            >
                {buttonType === 'link' || buttonType === 'large-link' ? (
                    <span
                        className={classnames('sgw-link__text', {
                            'sgw-link__text--icon-visible': icon,
                            'icon-right': icon && iconOnRightSide,
                        })}
                    >
                        {icon && !iconOnRightSide && <Icon type={icon} className="icon--22" />}
                        <span>{children}</span>
                        {icon && iconOnRightSide && <Icon type={icon} className="icon--22" />}
                    </span>
                ) : (
                    <>
                        {icon && !iconOnRightSide && (
                            <>
                                {isStandardIcon(targetButtonType) ? (
                                    <span className="sgw-button__icon-container">
                                        <Icon type={icon} className={iconClassNames} />
                                    </span>
                                ) : (
                                    <Icon type={icon} className={iconClassNames} />
                                )}
                            </>
                        )}
                        <>{children}</>
                        {icon && iconOnRightSide && (
                            <>
                                {isStandardIcon(targetButtonType) ? (
                                    <span className="sgw-button__icon-container">
                                        <Icon type={icon} className={iconClassNames} />
                                    </span>
                                ) : (
                                    <Icon type={icon} className={iconClassNames} />
                                )}
                            </>
                        )}
                    </>
                )}
            </button>
        );
    },
);

export default Button;
